module.exports = __webpack_public_path__ + "img/no-sticker.ae94c2b.gif";